import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import { useNavigate } from 'react-router-dom';
import '../GL/LoanReceiver.css';

const TBDLoanReceiver = () => {
  // State variables
  const [searchType, setSearchType] = useState('');
  const [query, setQuery] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const navigate = useNavigate();

  // Handle search type selection
  const handleSearchType = (type) => {
    setSearchType(type);
    setQuery('');
    setSuggestions([]);
  };

  // Fetch suggestions from backend
  const fetchSuggestions = async (value) => {
    if (!value) {
      setSuggestions([]);
      return;
    }

    try {
      const response = await axios.get(`${API_BASE_URL}/tbd-loan-reciever-suggestions`, {
        params: { type: searchType, value },
      });
      setSuggestions(response.data || []);
    } catch (error) {
      console.error('Error fetching suggestions:', error);
    }
  };

  // Handle input change
  const handleInputChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    fetchSuggestions(value);
  };

  // Handle suggestion click
  const handleSuggestionClick = (accountNo) => {
    if (!accountNo) {
      return;
    }
    const encodedValue = encodeURIComponent(accountNo);
    navigate(`/tbd-loan/receiver/tbd-loan-payment/account/${encodedValue}`);
  };

  // Handle back button click
  const handleBackClick = () => {
    navigate(-1); // Go back to the previous page
  };

  return (
    <div className="loan-receiver-container">
     

      <div className="loan-receiver-header">Loan Receiver</div>

      <div className="search-buttons">
        <button onClick={() => handleSearchType('name')}>Search by Name</button>
        <button onClick={() => handleSearchType('aadhaar')}>Search by Aadhaar</button>
        <button onClick={() => handleSearchType('phone')}>Search by Phone No</button>
      </div>
 
      {searchType && (
        <div className="input-container">
          <input
            type="text"
            placeholder={`Enter ${searchType}`}
            value={query}
            onChange={handleInputChange}
          />

          {/* Render suggestions */}
          {suggestions.length > 0 && (
            <ul className="suggestions-list">
              {suggestions.map((suggestion, index) => (
                <li
                  key={index}
                  onClick={() =>
                    handleSuggestionClick(suggestion.account_no)
                  }
                >
                  {suggestion.name ? `${suggestion.name} (${suggestion.account_no})` : 
                   suggestion.aadhaar ? `${suggestion.aadhaar} (${suggestion.account_no})` :
                   suggestion.phone ? `${suggestion.phone} (${suggestion.account_no})` :
                   suggestion.account_no}
                </li>
              ))}
            </ul>
          )}
          <div>

            </div>
        
        </div>
      )}
        {/* Back Button */}
 <button onClick={handleBackClick} className="back-button">
        Back
      </button>
    </div>
  );
};

export default TBDLoanReceiver;
